<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <span class="logo"> <b>{{ appName }}</b></span>
  </div>
</div>

<div class="header-container">
  <nb-actions size="medium">
    <nb-action id="button-refresh" class="notification-action">
      <button nbButton ghost status="primary" #btnRefresh>
        <nb-icon icon="refresh-outline" size="small" status="primary"></nb-icon>
      </button>
    </nb-action>

    <nb-action class="notification-action" routerLink="/app/notifications">
      <button nbButton ghost status="primary">
        <nb-icon icon="bell-outline" size="small" status="primary"></nb-icon>
      </button>
    </nb-action>

    <nb-action class="user-action" *ngIf="!isNative">
      <nb-user [nbContextMenu]="userMenu" nbContextMenuTag="user-menu" [onlyPicture]="userPictureOnly"
        [name]="user?.pegawai.nama" [picture]="user.avatar ? env_image + user.avatar:'/assets/images/user.png'">
      </nb-user>
    </nb-action>
  </nb-actions>

  <div class="internet-indicator" [ngClass]=" networkService.networkStatus.connected ? 'connected' : 'disconnected'">
  </div>
</div>